// import function to register Swiper custom elements
import { register } from 'swiper/swiper-element-bundle'
// register Swiper custom elements
register()
